import useSWR from "swr";
import getBuyerAPIDomain from "../getBuyerAPIDomain";
import getFacetCounts from "./getFacetCounts";
import { MappedFacetCounts, FacetType } from "./filters.type";
import { enabledCategories } from "./filtersConfig";
import { useSelector } from "react-redux";
import { StoreType } from "../StoreType";
import { GET_STATE } from "../redux/slices/appSlice";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

export function useCurrentFacet(
  allQueryStrings: any,
  currentFacet: FacetType | null
) {
  const {
    app: { isToUseAuthZero },
  }: StoreType = useSelector(GET_STATE);
  const { accessToken } = useAuth(!isToUseAuthZero);

  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  const getFacetCountUrl = buyerAPIDomain
    ? new URL(
        `${buyerAPIDomain.href}/search/facet?currentFacet=${currentFacet}`,
        buyerAPIDomain
      )
    : null;

  const appliedFilters = allQueryStrings["bq"];

  if (getFacetCountUrl && appliedFilters?.length > 0) {
    const valToAppend = allQueryStrings["bq"]
      .split("|")
      .filter((item) => item.split(":")[0] !== currentFacet)
      .join("|");
    if (valToAppend?.length > 0) {
      getFacetCountUrl.searchParams.append("bq", valToAppend as string);
    }
  }

  const freeSearchText = allQueryStrings["q"];
  if (freeSearchText) {
    getFacetCountUrl.searchParams.append("q", freeSearchText as string);
  }

  const missingMileage = allQueryStrings["missingMileage"];
  if (missingMileage) {
    getFacetCountUrl.searchParams.append(
      "missingMileage",
      missingMileage as string
    );
  }

  const awaitingAppraisal = allQueryStrings["awaitingAppraisal"];
  if (awaitingAppraisal) {
    getFacetCountUrl.searchParams.append(
      "awaitingAppraisal",
      awaitingAppraisal as string
    );
  }

  const requestOrigin = allQueryStrings["requestOrigin"];
  if (requestOrigin) {
    getFacetCountUrl.searchParams.append(
      "requestOrigin",
      requestOrigin as string
    );
  }

  const isMultiselectFilter =
    enabledCategories.multiselect.includes(currentFacet);
  const {
    data: facet,
    error: facetError,
    mutate: mutateCurrentFacet,
  } = useSWR<MappedFacetCounts>(
    currentFacet && isMultiselectFilter && (accessToken || !isToUseAuthZero)
      ? [getFacetCountUrl.href, currentFacet, accessToken, isToUseAuthZero]
      : null,
    getFacetCounts,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  return {
    facet,
    facetError,
    mutateCurrentFacet,
  };
}
